
(function() {
  var result = { translations: { "es": { "i18n": { "duration": { "seconds": "{{ seconds }} seg", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "es": "static-7.929"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.929",
    "ar-eg": "static-7.929",
    "bg": "static-7.929",
    "bn": "static-7.929",
    "ca-es": "static-7.929",
    "cs": "static-7.929",
    "da": "static-7.929",
    "de": "static-7.929",
    "el": "static-7.929",
    "en-gb": "static-7.929",
    "en": "static-7.929",
    "es-mx": "static-7.929",
    "es": "static-7.929",
    "fi": "static-7.929",
    "fr-ca": "static-7.929",
    "fr": "static-7.929",
    "he-il": "static-7.929",
    "hr": "static-7.929",
    "hu": "static-7.929",
    "id": "static-7.929",
    "it": "static-7.929",
    "ja": "static-7.929",
    "ko": "static-7.929",
    "lt": "static-7.929",
    "ms": "static-7.929",
    "nl": "static-7.929",
    "no": "static-7.929",
    "pl": "static-7.929",
    "pt-br": "static-7.929",
    "pt-pt": "static-7.929",
    "ro": "static-7.929",
    "ru": "static-7.929",
    "sk": "static-7.929",
    "sl": "static-7.929",
    "sv": "static-7.929",
    "th": "static-7.929",
    "tl": "static-7.929",
    "tr": "static-7.929",
    "uk": "static-7.929",
    "vi": "static-7.929",
    "x-pseudo": "static-7.929",
    "zh-cn": "static-7.929",
    "zh-hk": "static-7.929",
    "zh-tw": "static-7.929"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es', {version: 'static-7.929'}); }
})();


